import getOwnerDocument from './getOwnerDocument';
import getStyle from './getStyle';
import isScrollable from './isScrollable';
/**
 * Returns the closest ancestor element that is scrollable. If a
 * scrollable ancestor element cannot be found the owner document for
 * the provided element is returned.
 */

export default function getScrollParent(element) {
  var includeHidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var position = getStyle(element, 'position');
  var excludeStatic = position === 'absolute';

  if (position === 'fixed') {
    return getOwnerDocument(element);
  }

  var scrollParent = element.parentElement;

  while (scrollParent && !isScrollable(scrollParent, excludeStatic, includeHidden)) {
    scrollParent = scrollParent.parentElement;
  }

  if (!scrollParent) {
    return getOwnerDocument(element);
  }

  return scrollParent;
}
//# sourceMappingURL=getScrollParent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/blaze-consumer/~/@flowio/browser-helpers/lib/esm/getScrollParent.js
// module id = 474
// module chunks = 0 1